import {createFileRoute} from '@tanstack/react-router';

import {VisitorGroupsPage} from '@/modules/admin-visitors/pages/VisitorGroupsPage';

export const Route = createFileRoute('/_authenticated/admin/visitors/')({
  component: VisitorGroupsPage,
});
